'use client';
import { XYCHART_CATEGORY_LABEL_COLOR } from './xychart-constants';
import type { XYChartLayout } from './xychart-types';
export interface XYChartCategoryLabelsProps {
    layout: XYChartLayout;
}
export function XYChartCategoryLabels({ layout }: XYChartCategoryLabelsProps) {
    if (layout.horizontal) {
        return (<>
        {layout.categories.map((category) => (<text key={`category-h-${category.fullText}-${category.position}`} x={-10} y={category.position + 4} textAnchor="end" fontSize={12} fontWeight={500} fill={XYCHART_CATEGORY_LABEL_COLOR}>
            {category.text}
          </text>))}
      </>);
    }
    const labelY = layout.plotHeight + 18;
    return (<>
      {layout.categories.map((category) => {
            if (layout.rotateCategoryLabels) {
                return (<text key={`category-${category.fullText}-${category.position}`} x={category.position} y={labelY} transform={`rotate(-32 ${category.position} ${labelY})`} textAnchor="end" fontSize={11} fontWeight={500} fill={XYCHART_CATEGORY_LABEL_COLOR}>
              {category.text}
            </text>);
            }
            return (<text key={`category-${category.fullText}-${category.position}`} x={category.position} y={labelY} textAnchor="middle" fontSize={12} fontWeight={500} fill={XYCHART_CATEGORY_LABEL_COLOR}>
            {category.text}
          </text>);
        })}
    </>);
}
